import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import LogoFooter from "../assets/logo-asifc.png"
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Section À propos */}
          <div className="footer-section">
            <img src={LogoFooter} className='logo-footer'/>
            <p className="footer-description">
              Association Solidarité Internationale France-Comores Dans le Rhône. 
              Engagée pour le développement et l'accompagnement des communautés comoriennes.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/p/Association-Solidarit%C3%A9-Internationale-France-Comores-Rh%C3%B4ne-ASIFC-Rh%C3%B4ne-100086731297999/" className="social-icon" aria-label="Facebook"><FaFacebook size={30} color='white' /></a>
              <a href="https://www.instagram.com/asifcrhone/" className="social-icon" aria-label="Instagram"><FaInstagram size={30} color='white' /></a>
              <a href="https://www.linkedin.com/in/asifc-rhone-006815424/" className="social-icon" aria-label="LinkedIn"><FaLinkedin size={30} color='white' /></a>
            </div>
          </div>

          {/* Section Liens rapides */}
          <div className="footer-section">
            <h3>Liens rapides</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/actualites">Actualités</Link></li>
              <li><Link to="/permanence-numerique">Permanence Numérique</Link></li>
              <li><Link to="/benevole">Devenir Bénévole</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Section Informations */}
        <div className="footer-section">
          <h3>Informations</h3>
          <ul className="footer-links">
            <li><Link to="/mentions-legales">Mentions Légales</Link></li>
            <li><Link to="/politique-confidentialite">Politique de Confidentialité</Link></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); localStorage.removeItem('cookieConsent'); window.location.reload(); }}>Gérer les cookies</a></li>
            <li><Link to="/admin/login" className="footer-admin-link">Admin</Link></li>
          </ul>
        </div>

          {/* Section Contact */}
          <div className="footer-section">
            <h3>Contact</h3>
            <ul className="footer-contact">
              <li>
                <span className="contact-icon">📧</span>
                <a href="mailto:asifc.rhone@gmail.com">asifc.rhone@gmail.com</a>
              </li>
              <li>
                <span className="contact-icon">📍</span>
                <span>13 avenue Marcel Paul, Vénissieux, France, 69200</span>
              </li>
              <li>
                <span className="contact-icon">⏰</span>
                <span>Lun - Sam : 9h - 18h</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="footer-content">
          <p>&copy; {new Date().getFullYear()} ASIFC - Association Solidarité Internationale France-Comores Dans le Rhône. Tous droits réservés.</p>
          <p className="footer-credits">Conçu avec ❤️ pour la communauté comorienne by <strong><a href='https://dreamdev.fr/' target='_blank'>DreamDev</a></strong></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;